import { FC } from 'react';

import { useAppSelector } from '../../hooks/redux';

export const BonusesCard: FC = () => {
  const wallet = useAppSelector((state) => state.walletSlice);

  const formattedValue = new Intl.NumberFormat('ru-RU').format(wallet.wallet ? wallet.wallet.balance : 0);

  return (
    <div className="w-[267px] h-[130px] bg-black rounded-[20px] flex flex-col place-content-between font-comfortaa p-3 ">
      <p className="text-[20px] text-[#DEC05E] font-bold">БОНУСНЫЙ БАЛАНС</p>
      <p className="text-[32px] text-[#FFFFFF] font-manrope font-medium">{formattedValue}</p>
    </div>
  );
};
